/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { EmbersButton } from '../../button/button';
import { PageTemplate } from '../../templates/pageTemplate';
import { ContentTemplate } from '../../templates/contentTemplate';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import InternetErrorImage from './assets/image-error-noInternet.svg';
export var NoInternetError = function NoInternetError() {
  var intl = useIntl();
  useDocumentTitle(intl.formatMessage({
    id: 'embers.pageTitle.error.noInternetConnection',
    defaultMessage: 'No internet connection - Promethean'
  }));

  // to consider: does this work for all projects consuming this?
  var refreshPage = function refreshPage() {
    return window.location.reload();
  };
  return /*#__PURE__*/React.createElement(PageTemplate, null, /*#__PURE__*/React.createElement(ContentTemplate, {
    type: "error",
    pageTitle: intl.formatMessage({
      id: 'embers.globalError.noInternet.title',
      defaultMessage: 'No internet connection'
    }),
    errorMessage: intl.formatMessage({
      id: 'embers.globalError.noInternet.body',
      defaultMessage: 'We are unable to connect to the internet at this time. Please check your internet settings and try again.'
    }),
    errorImage: InternetErrorImage,
    errorButton: /*#__PURE__*/React.createElement(EmbersButton, {
      onClick: refreshPage,
      startIcon: /*#__PURE__*/React.createElement("span", {
        className: "icon-reload"
      })
    }, intl.formatMessage({
      id: 'embers.button.reload',
      defaultMessage: 'Reload'
    }))
  }));
};